import './style.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { showPromo, loadPromos, apply as applyPromo } from './actions';
import { showedPromo } from 'components/link/actions';
import { track } from 'shared/models/analytic';
import Modal from '../ui/modal';
import Text from '../ui/text';
import View from '../ui/view';
import Button from '../ui/button';

class Promo extends React.Component {
  constructor(props) {
    super(props);
    this.state = { promoCode: props.linkPromo || '' };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.user && !!nextProps.user) {
      this.props.loadPromos();
    }
  }

  displayValue(promo) {
    if (!promo) return '';
    switch (promo.value_type) {
      case '%':
        return `${100 * promo.value}%`;
      case 'hour':
        return promo.value === 1 ? `${promo.value} HR` : `${promo.value} HRS`;
      default:
        return `$${promo.value}`;
    }
  }

  handleChange(e) {
    this.setState({ promoCode: e.target.value });
  }

  applyCode(event) {
    event.preventDefault();
    this.props.applyPromo(this.state.promoCode).then(action => {
      if (action) {
        this.setState({ promoCode: '' });
        this.select(action.promo || action.credit);
        return;
      }
      track('Coupon Denied', {
        order_id: this.props.orderId,
        coupon: this.promoCode,
        reason: this.props.userPromo.error
      });
    });
    track('Coupon Entered', {
      order_id: this.props.orderId,
      coupon: this.promoCode
    });
  }

  select(item) {
    if (this.props.selectPromo) {
      this.props.selectPromo(item);
      track('Coupon Applied', {
        order_id: this.props.orderId,
        coupon_id: item.code,
        coupon_name: item.desc,
        discount: item.val
      });
    }
    window.setTimeout(() => this.close(), 500);
  }

  remove() {
    this.props.removePromo();
    window.setTimeout(() => this.close(), 500);
  }

  close() {
    this.props.showPromo(false);
    this.props.showedPromo();
  }

  render() {
    this.displayValue = this.displayValue.bind(this);
    this.promoSelectable =
      !!this.props.selectPromo &&
      this.props.userPromo.codes &&
      !!this.props.userPromo.codes.length;

    return (
      <Modal
        isOpen={this.props.linkPromo || this.props.show}
        handleClose={this.close.bind(this)}
      >
        {!this.props.user && (
          <View margin="sm" padding="md">
            <Text error={true}>
              You must log in or create an account before adding a promo code.
            </Text>
          </View>
        )}

        {this.props.user && (
          <View
            margin="sm"
            padding={{ sides: 'sm', top: 'md' }}
            className="promo"
          >
            <Text tag="h3" className="text-center" title={true} size="sm">
              Promos & Discounts
            </Text>

            <View margin="md">
              <View padding="sm">
                <form
                  className="promo__form"
                  onSubmit={this.applyCode.bind(this)}
                >
                  <input
                    defaultValue={this.state.promoCode}
                    type="text"
                    placeholder="Enter a Promo Code or Gift Card"
                    onChange={this.handleChange.bind(this)}
                  />
                  <Button
                    type="submit"
                    className="btn-primary"
                    disabled={this.state.promoCode === ''}
                    loading={this.props.userPromo.loading}
                  >
                    Apply
                  </Button>
                </form>
              </View>
              {!!this.props.userPromo.error && (
                <View
                  padding={{ sides: 'sm' }}
                  margin={this.promoSelectable ? 'sm' : 'md'}
                >
                  <Text error={true}>{this.props.userPromo.error}</Text>
                </View>
              )}
            </View>

            {this.promoSelectable && (
              <Fragment>
                <hr className="light" />

                <div className="promo-list text-left">
                  <View padding="sm">
                    {!!this.props.userPromo.credit && (
                      <div
                        className={
                          'promo-list-item promo-list-item--credit' +
                          (this.props.selectedPromo &&
                          this.props.selectedPromo.value_type === 'credit'
                            ? ' active'
                            : '')
                        }
                        onClick={this.select.bind(this, {
                          credit: this.props.userPromo.credit
                        })}
                      >
                        <span className="promo-list-item-value promo-list-item-value--credit">
                          ${this.props.userPromo.credit.balance}
                        </span>
                        <div className="promo-list-item-info">
                          <span className="promo-list-item-code">
                            Available Gift Credit
                          </span>
                          <span className="promo-list-item-description">
                            ${this.props.userPromo.credit.balance}
                          </span>
                        </div>
                        <span className="promo-list-item-selected" />
                      </div>
                    )}

                    {(this.props.userPromo.codes || []).map(item => (
                      <div
                        className={
                          'promo-list-item' +
                          (this.props.selectedPromo &&
                          this.props.selectedPromo.code === item.code
                            ? ' active'
                            : '')
                        }
                        onClick={this.select.bind(this, item)}
                        key={item.code}
                      >
                        <span className="promo-list-item-value">
                          {this.displayValue(item)}
                        </span>
                        <div className="promo-list-item-info">
                          <span className="promo-list-item-code">
                            {item.label}
                          </span>
                          <span className="promo-list-item-description">
                            {item.desc}
                          </span>
                        </div>
                        <span className="promo-list-item-selected" />
                      </div>
                    ))}
                  </View>
                </div>
              </Fragment>
            )}
            {!!this.props.removePromo &&
              !!this.props.selectedPromo && (
                <div className="promo-list">
                  <hr className="light" />

                  <View padding="sm">
                    <button
                      className="btn-small btn-secondary text-secondary"
                      onClick={this.remove.bind(this)}
                    >
                      Remove Promo Code
                    </button>
                  </View>
                </div>
              )}
          </View>
        )}
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    userPromo: state.promo,
    show: state.promo.show,
    linkPromo: state.link.promo,
    user: state.login.user
  };
}

export default connect(mapStateToProps, {
  applyPromo,
  showPromo,
  showedPromo,
  loadPromos
})(Promo);



// WEBPACK FOOTER //
// ./shared/components/promo/index.js